import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionKey } from '../../utils/keys';
import { useCachedCollection } from '../cache';
export const useCollection = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const collectionKey = getCollectionKey({ variables, fields });
    const cachedCollection = useCachedCollection(variables === null || variables === void 0 ? void 0 : variables.id);
    return useQuery(collectionKey, () => client.collections.get(variables, fields), {
        placeholderData: cachedCollection,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useCollection.js.map